import service from './../../../services/warehouse/warehouseItem';
import warehouseItemList from './warehouseItemList'

export default {
    namespaced: true,
    modules: {
        list: warehouseItemList
    },
    actions: {
        create(context, payload) {
            return new Promise((resolve,reject) => {
                service.create(payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
            })
        },
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                service.findByID(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                service.update(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        remove(context, payload) {
            return new Promise((resolve, reject) => {
                service.remove(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}